import React from 'react'
import PropTypes from 'prop-types'
import Form from 'components/form'
import { useForm } from 'react-hook-form'
import Button from 'components/Button'
import PublicModalDrawer from 'components/PublicModalDrawer'
import { useMutation } from 'react-query'
import ApiClient from 'data/api/api_client'
import useErrorHandler from 'data/hooks/useErrorHandler'

const CustomerForgottenPasswordModal = ({ isOpen = false, onClose = () => { } }) => {
  const handleError = useErrorHandler()

  const { register, handleSubmit, getValues, setError, formState: { errors }, reset } = useForm()

  const resetMutation = useMutation(
    () => ApiClient.auth.triggerPasswordReset(getValues('email')),
    {
      onSuccess: () => {
        onClose()
        reset()
      },
      onError: (error) => {
        handleError(error, setError)
      },
    },
  )

  return (
    <PublicModalDrawer isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col justify-between h-full z-30">
        <form onSubmit={handleSubmit(resetMutation.mutate)} className="flex flex-col text-grey-800">
          <h1 className="font-serif font-bold text-26 leading-28 tracking-title">
            Reset your password
          </h1>
          <p className="mt-80">
            {'If you\'ve forgotten your password, enter your email here and we\'ll send you a link to reset it'}
          </p>

          <label className="text-14 leading-20 mt-50 font-sans">
            Email Address
            <Form.Input
              style="customer"
              className="mt-10"
              placeholder="Your email here"
              error={errors?.email?.message}
              {...register('email')}
            />
          </label>

          <Button type="submit" block className="mt-30 uppercase leading-20" isLoading={resetMutation.isLoading}>Send Reset Link</Button>
        </form>
      </div>
    </PublicModalDrawer>
  )
}

CustomerForgottenPasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  token: PropTypes.string,
}

export default CustomerForgottenPasswordModal
